"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.sync = void 0;
function removeListeners(event, db) {
    var listeners = db.events.listeners(event);
    listeners.forEach(function (listener) {
        db.events.removeListener(event, listener);
    });
    return function () {
        listeners.forEach(function (listener) {
            db.events.addListener(event, listener);
        });
    };
}
/**
 * Synchronizes database operations across multiple clients.
 */
function sync(db) {
    var IS_BROWSER = typeof window !== 'undefined';
    var SUPPORTS_BROADCAST_CHANNEL = typeof BroadcastChannel !== 'undefined';
    if (!IS_BROWSER || !SUPPORTS_BROADCAST_CHANNEL) {
        return;
    }
    var channel = new BroadcastChannel('mswjs/data/sync');
    channel.addEventListener('message', function (event) {
        var _a = event.data, operationType = _a.operationType, payload = _a.payload;
        var _b = __read(payload), sourceId = _b[0], args = _b.slice(1);
        // Ignore messages originating from unrelated databases.
        // Useful in case of multiple databases on the same page.
        if (db.id !== sourceId) {
            return;
        }
        // Remove database event listener for the signaled operation
        // to prevent an infinite loop when applying this operation.
        var restoreListeners = removeListeners(operationType, db);
        // Apply the database operation signaled from another client
        // to the current database instance.
        // @ts-ignore
        db[operationType].apply(db, __spreadArray([], __read(args)));
        // Re-attach database event listeners.
        restoreListeners();
    });
    function broadcastDatabaseEvent(operationType) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            channel.postMessage({
                operationType: operationType,
                payload: args
            });
        };
    }
    db.events.on('create', broadcastDatabaseEvent('create'));
    db.events.on('update', broadcastDatabaseEvent('update'));
    db.events.on('delete', broadcastDatabaseEvent('delete'));
}
exports.sync = sync;
